import $ from 'jquery';
import '../vendor/slick';
import {register} from '@shopify/theme-sections';

register('product-gallery-slider', {
  onLoad() {
    this.$container = $(this.container);
    this.namespace = `.${this.id}`;
    this.$slideshow = $('[data-product-gallery-slider]', this.$container);

    this.$slideshow.slick({
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      cssEase: 'ease-in-out',
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '[data-product-thumbnails-slider]',
      responsive: [
        {
          breakpoint: 800,
          settings: {
            arrows: true,
          }
        }
      ]
    });
  },

  onBlockSelect(event) {
    const $target = $(event.target);
    const $slide = $target.closest('[data-slick-index]');
    const index = $slide.attr('data-slick-index');

    this.$slideshow.slick('slickPause');
    this.$slideshow.slick('slickGoTo', index);
  },

  onDeselect() {
    this.$slideshow.slick('slickPlay');
  },

  onUnload() {
    this.$container.off(this.namespace);
    this.$slideshow.slick('unslick');
  },
});

register('product-thumbnails-slider', {
  onLoad() {
    this.$container = $(this.container);
    this.namespace = `.${this.id}`;
    this.$slideshow = $('[data-product-thumbnails-slider]', this.$container);

    this.$slideshow.slick({
      vertical: true,
      verticalSwiping: true,
      arrows: true,
      dots: false,
      autoplay: false,
      infinite: false,
      cssEase: 'ease-in-out',
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '[data-product-gallery-slider]',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 5,
            vertical: false,
            verticalSwiping: false,
            arrows: false
          }
        }
      ]
    });

    this.$slideshow.on('init', () => {
      const $prevArrow = this.$container.find('.slick-prev');
      $prevArrow.addClass('disabled');
    });

    this.$slideshow.on('afterChange', (event, slick, currentSlide) => {
      const totalSlides = slick.slideCount;
      const $nextArrow = this.$container.find('.slick-next'); 
      const $prevArrow = this.$container.find('.slick-prev'); 
      const $nextArrowMain = $('[data-product-gallery-slider]').find('.slick-next');
      const $prevArrowMain = $('[data-product-gallery-slider]').find('.slick-prev');

      if (currentSlide === totalSlides - 1) {
        $nextArrow.addClass('disabled');
        $nextArrowMain.addClass('disabled');
      } else if (currentSlide === 0) {
        $prevArrow.addClass('disabled');
        $prevArrowMain.addClass('disabled');
      } else {
        $nextArrow.removeClass('disabled');
        $prevArrow.removeClass('disabled');
        $nextArrowMain.removeClass('disabled');
        $prevArrowMain.removeClass('disabled');
      }

    });
  },

  onBlockSelect(event) {
    const $target = $(event.target);
    const $slide = $target.closest('[data-slick-index]');
    const index = $slide.attr('data-slick-index');

    this.$slideshow.slick('slickPause');
    this.$slideshow.slick('slickGoTo', index);
  },

  onDeselect() {
    this.$slideshow.slick('slickPlay');
  },

  onUnload() {
    this.$container.off(this.namespace);
    this.$slideshow.slick('unslick');
  },
});
